import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CookieConsentProvider } from '@/context/CookieConsentContext';
import CookieBanner from '@/components/CookieBanner';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Work from '@/pages/Work';
import Insights from '@/pages/Insights';
import InsightArticle from '@/pages/InsightArticle';
import Contact from '@/pages/Contact';
import Privacy from '@/pages/Privacy';
import Terms from '@/pages/Terms';

function App() {
  return (
    <HelmetProvider>
      <CookieConsentProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/work" element={<Work />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightArticle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
            {/* Banner lives outside Routes so it persists across navigation and reads the
                same CookieConsentContext as the Footer "Cookie settings" link. */}
            <CookieBanner />
          </BrowserRouter>
        </div>
      </CookieConsentProvider>
    </HelmetProvider>
  );
}

export default App;
